module.exports = __webpack_public_path__ + "img/bnodata.2f5800c2.png";